<template>
  <li>
    <router-link :to="{name: 'assignmentDetail', params: {id: blast.id}}" class="wrapper">
      <div class="poster">
        <figure>
          <poster-image :src="blast.assignment.posterUrl" />
        </figure>
        <div class="poster-body">
          <div class="status">
            <sprite :name="status.icon" title="Status" />
            {{ status.label }}
          </div>
          <div class="blast-due" v-if="!blast.isClosed">
            <sprite name="iconClock" title="Due Date" />
            {{ dueDateStamp }}
          </div>
        </div>
      </div>
      <div class="body">
        <h3 class="blast-title" v-html="title"></h3>
        <h4 class="blast-prompt">{{ blast.assignment.prompt }}</h4>
        <div class="excerpt">
          <p>{{ blast.assignment.blurb }}</p>
        </div>
        <div class="blast-foot">
          <div class="blast-cta">
            <btn>Continue Reading</btn>
          </div>
          <div class="blast-type">
            <sprite :name="'icon'+blast.assignmentType+'Chrome'" title="Assignment Type: Blast" />
          </div>
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
  export default {
    name: 'assignmentList',
    props: {
      blast: {
        type: Object,
        required: true
      }
    },
    computed: {
      title () {
        let words = this.blast.assignment.name.split(' ')
        const lastWords = words.splice(-2, 2).join('&nbsp;')
        words.push(lastWords)
        return words.join(' ')
      },
      dueDateStamp () {
        return (this.blast.pastDue) ? "Past Due" : moment(this.blast.dueDate).fromNow(true)
      },
      status () {
        if(this.blast.isOpen) {
          return {icon: "iconStar", label: "Assigned"}
        }
        if(this.blast.isClosed || this.blast.reviewsGivenCount>=this.blast.assignment.maxReview) {
          return {icon: "iconCheck", label: "Complete"}
        }
        if(this.blast.reviewsAvailableCount) {
          return {icon: "iconReview", label: "Review Available"}
        }
        return {icon: "iconHourglass", label: "Waiting for Review"}
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~globals";

  li {
    position:relative; background:#fff; display:block; box-shadow:$box-shadow; border-radius:3px;
  }
  li + li {
    margin-top:2rem;
    @include media(xlarge) {
      margin-top:$gutter;
    }
  }
  figure {
    position:relative; margin-bottom:.75rem;
    @include media(xxlarge) {
      margin-bottom:0;
    }
    img {
      display:block;
    }
  }
  figcaption {
    @include font-size(medium, $headline:true);
    @include position(absolute, auto $gutter $gutter/2);
    display:flex; justify-content:space-between; color:#fff;
    > div {
      display:flex; align-items:center;
    }
    svg {
      @include size(2.8rem);
      fill: #fff; margin-right:1rem;
    }
  }
  .wrapper {
    text-decoration:none; color:inherit;
    @include media(xxlarge) {
      display:flex; flex-basis:100%;
    }
  }
  .poster {
    position:relative;
    @include media(xxlarge) {
      flex-basis:percentage(1/2);
    }
    @include media(xxlarge) {
      flex-basis:60%;
    }
  }
  .poster-body {
    @include position(absolute, 60% 0 0 0);
    display:flex; justify-content:space-between; align-items:flex-end; background:linear-gradient(rgba($color-primary-darker, 0), rgba($color-primary-darker, .9)); color:$color-white; padding:1.5rem 2rem;
    svg {
      @include size(2rem);
      fill:$color-white; margin-right:1rem;
    }
    & > div {
      display:flex; align-items:center;
    }
  }
  .body {
    padding:2.5rem;
    @include media(xxlarge) {
      display:flex; flex-direction: column; flex:1;
    }
  }
  .channel {
    svg {
      @include size(1.6rem);
      margin-right:1rem;
    }
  }
  .blast-title {
    @include font-size(xxlarge, $headline:true);
    @include media(small) {
       font-size:3.5rem; line-height:1.2;
    }
    @include media(xxlarge) {
      font-size:3rem;
    }
    @include media(xxxlarge) {
      font-size:4rem;
    }
    color:$color-black;
  }
  .blast-prompt {
    @include font-size(xlarge, $weight:600, $line-height:1.2);
    @include media(xxlarge) {
      font-size:2rem;
    }
    @include media(xxxlarge) {
      font-size:2.4rem;
    }
    margin:.5rem 0 0; color:$color-black;
  }
  .blast-foot {
    display:flex; justify-content:space-between; align-items:center;
  }
  .blast-type {
    @include size(3.5rem);
  }
  .channel {
    margin:0 0 .75rem;
  }
  .excerpt {
    font-size:1.8rem; line-height:1.5; overflow:hidden; position:relative; margin-top:1.5rem; margin-bottom:3rem; flex:1 1 0;
    @include media(small, xxlarge) {
      max-height:6em;
    }
    &::after {
      @include position(absolute, 40% 0 0 0);
      content:''; background:linear-gradient(rgba(#eee, 0), rgba(#fff, 1));
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AssignmentList/item.vue